"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var stateful_1 = require("../stateful");

exports.default = function (App) {
  var permission = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (props) {
    var permissions = stateful_1.Credentials.getPermissions();
    var permissionsChecked = permission === null || permissions && permissions.includes(permission);

    if (stateful_1.Credentials.getProfile() && permissionsChecked) {
      return react_1.default.createElement(App, Object.assign({}, props));
    }

    return react_1.default.createElement(react_router_dom_1.Redirect, {
      to: "/logout"
    });
  };
};